import { createBrowserRouter, type RouteObject } from 'react-router';
import { HomePage } from '@/pages/home/HomePage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { TunerPage } from '@/pages/tuner/TunerPage';
import { AppShell } from './AppShell';
import { RouteError } from './RouteError';

// Dev-only tools. `import.meta.env.DEV` is false in production builds, so these are removed there.
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: 'dev/engine',
        lazy: async () => ({
          Component: (await import('@/pages/dev/EngineInspectorPage')).default,
        }),
      },
    ]
  : [];

export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'tuner', element: <TunerPage /> },
      ...devRoutes,
      { path: '*', element: <RouteError /> },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}
